import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
  FormControl,
  FormControlLabel,
  Switch,
  InputAdornment
} from '@mui/material';
import { Package } from '../../../types/Venue';

interface PackagePricingFormProps {
  packageData: Partial<Package>;
  onChange: (data: Partial<Package>) => void;
}

const PackagePricingForm: React.FC<PackagePricingFormProps> = ({
  packageData,
  onChange
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    
    if (name === 'price' || name === 'discountedPrice') {
      const numValue = parseFloat(value);
      onChange({ [name]: isNaN(numValue) ? 0 : numValue });
    } else {
      onChange({ [name]: value });
    }
  };

  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    onChange({ [name]: checked });
  };

  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Package Pricing
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id="price"
            name="price"
            label="Price"
            type="number"
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
              inputProps: { min: 0, step: "0.01" }
            }}
            value={packageData.price || ''}
            onChange={handleInputChange}
            helperText="Regular price of this package"
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            id="discountedPrice"
            name="discountedPrice"
            label="Original Price (if discounted)"
            type="number"
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
              inputProps: { min: 0, step: "0.01" }
            }}
            value={packageData.discountedPrice || ''}
            onChange={handleInputChange}
            helperText="Optional: Show original price if offering a discount"
          />
        </Grid>
        
        <Grid item xs={12}>
          <FormControl component="fieldset" variant="standard">
            <FormControlLabel
              control={
                <Switch
                  checked={packageData.isActive || false}
                  onChange={handleSwitchChange}
                  name="isActive"
                />
              }
              label="Make package active and available for purchase"
            />
          </FormControl>
        </Grid>
      </Grid>
      
      <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
        Note: You can change the availability and active status of your package at any time.
      </Typography>
    </Box>
  );
};

export default PackagePricingForm;
